import React from "react"
import PropTypes from "prop-types"
import styles from "./Row.module.css"
import gridStyles from "../../utils/gridStyles"

const Row = ({ children }) => (
  <div className={`${gridStyles("row")} ${styles.rowContainer}`}>
    {children}
  </div>
)

Row.propTypes = {
  children: PropTypes.node,
}

export default Row
